import {
    Button,
    FormLabel,
    Grid,
    Paper,
    CircularProgress,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell
} from '@material-ui/core';
import React, { useState, useCallback, useEffect, useContext } from 'react';
import { SelectBox, TextBox } from '../../../Core/FormInput';
import { makeStyles, withStyles } from '@material-ui/styles';
import DialogComp from '../../../Core/Modal/dialogModal';
import TCardModal from './TcardModal';
import { getTCards_GetVehicles } from '../../../Core/Service/checkInRole';
import _ from 'lodash';
import AppContext from '../../../App/AppContext';
import moment from 'moment';

const useStyles = makeStyles(() => ({
    button: {
        borderRadius: '8px',
        padding: '5px 16px',
        textTransform: 'none',
        color: '#fff',
        backgroundColor: '#1976d2',
        '&:hover': {
            backgroundColor: '#155a9d'
        }
    },
    dropdownContainer: {
        position: 'absolute',
        zIndex: 1000,
        width: '100%',
        maxHeight: '200px',
        overflowY: 'auto',
        marginTop: '2px',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
    },
    dropdownItem: {
        textAlign: 'left',
        padding: '8px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#f5f5f5'
        }
    },
    highlightedItem: {
        backgroundColor: '#C24B3D',
        color: 'white',
        '&:hover': {
            backgroundColor: '#C24B3D'
        }
    }
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: 'lightgrey',
        // color: theme.palette.common.white,
        padding: '5px',
        fontWeight: 800
    },
    body: {
        fontSize: 14,
        padding: '5px',
        fontWeight: 600
        // border: '1px solid rgba(0, 0, 0, 0.1)'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        cursor: 'pointer',
        background: '#f5f5f5',
        '&:hover': {
            backgroundColor: 'grey'
        }
        // '&:nth-of-type(odd)': {
        //     backgroundColor: theme.palette.action.hover
        // }
    }
}))(TableRow);

const GetTCardDashboard = () => {
    const { showToast, showModal, portalSettings } = useContext(AppContext);
    const classes = useStyles();

    const [state, setState] = useState({
        regNumberToSearch: '',
        cashAccountTypeCategoryID: null,
        categories: [],
        vehicleList: [],
        loading: false,
        selectedVehicle: {}
    });

    const [isShow, setIsShow] = useState({ showJobPopup: false });
    const [showDropdown, setShowDropdown] = useState(false);

    // API Call with Debounce
    const fetchVehicles = async (regNumber) => {
        if (regNumber.length > 2) {
            setState((prev) => ({ ...prev, loading: true }));
            try {
                let res = await getTCards_GetVehicles(regNumber);
                setState((prev) => ({
                    ...prev,
                    vehicleList: res.data.tCards,
                    loading: false
                }));
                if (res.data.tCards.length > 0) {
                    setShowDropdown(true);
                } else {
                    showToast('Vehicles not found!');
                    setShowDropdown(false);
                }
            } catch (error) {
                console.error('Error fetching vehicles:', error);
                setState((prev) => ({ ...prev, loading: false }));
            }
        } else {
            setShowDropdown(false);
            setState((prev) => ({
                ...prev,
                vehicleList: [],
                loading: false
            }));
        }
    };

    const debouncedFetchVehicles = useCallback(_.debounce(fetchVehicles, 500), []);

    const fieldChange = (e) => {
        const { name, value } = e.target;
        const trimmedValue = value.trim().toUpperCase();
        setState((prev) => ({ ...prev, [name]: trimmedValue }));
        debouncedFetchVehicles(trimmedValue);
    };

    const handleVehicleSelect = (vehicle) => {
        console.log(vehicle);
        setIsShow((prev) => ({ ...prev, showJobPopup: true }));
        setState((prev) => ({ ...prev, selectedVehicle: vehicle }));
    };

    const handleAddPopUp = (name) => {
        setIsShow((prev) => ({ ...prev, [name]: true }));
    };

    const closeWarningModal = (isClose) => {
        setIsShow((prev) => ({ ...prev, showJobPopup: false }));
    };

    const modalTitleRender = () => {
        return (
            <Grid container justifyContent="space-between" alignItems="center">
                <Grid item>Customer: {state.selectedVehicle.customer}</Grid>
                <Grid item>Reg No: {state.selectedVehicle.reg}</Grid>
            </Grid>
        );
    };

    return (
        <div style={{ padding: '20px' }}>
            <Grid container alignItems="center" spacing={2} justifyContent="center">
                <Grid item xs={8} md={6} lg={4} style={{ position: 'relative' }}>
                    <FormLabel>Enter Registration Number</FormLabel>
                    <TextBox autoFocus name="regNumberToSearch" onChange={fieldChange} value={state.regNumberToSearch} />
                    {state.loading && <CircularProgress size={24} style={{ position: 'absolute', right: 15, top: 25 }} />}
                    {showDropdown && state.vehicleList.length > 0 && (
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell>Reg No</StyledTableCell>
                                        <StyledTableCell>Customer</StyledTableCell>
                                        <StyledTableCell>Vin</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {state.vehicleList.map((vehicle) => (
                                        <>
                                            <StyledTableRow key={vehicle.loanVehicleID} onClick={() => handleVehicleSelect(vehicle)} cursor="pointer">
                                                <StyledTableCell> {vehicle.reg || 'N/A'}</StyledTableCell>
                                                <StyledTableCell>{vehicle.customer || 'N/A'}</StyledTableCell>
                                                <StyledTableCell>{vehicle.vin || 'N/A'}</StyledTableCell>
                                            </StyledTableRow>
                                        </>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </Grid>
                {/* <Grid item>
                    <Button variant="contained" className={classes.button} onClick={() => handleAddPopUp('showJobPopup')}>
                        Show Job
                    </Button>
                </Grid> */}
            </Grid>
            {isShow.showJobPopup && (
                <DialogComp title={'Crate T-Card'} maxWidth="xl" onClose={() => closeWarningModal()} fullWidth overflow="auto" fullScreen>
                    <TCardModal selectedVehicle={state.selectedVehicle} onClose={closeWarningModal} />
                </DialogComp>
            )}
        </div>
    );
};

export default GetTCardDashboard;
